import PropTypes from 'prop-types';
import React from 'react';
import Modal from '../../containers/modal.jsx';
import Box from '../box/box.jsx';
import {defineMessages, injectIntl, intlShape, FormattedMessage} from 'react-intl';

import booleanInputIcon from './icon--boolean-input.svg';
import textInputIcon from './icon--text-input.svg';
import labelIcon from './icon--label.svg';

import styles from './custom-procedures.css';

const messages = defineMessages({
    myblockModalTitle: {
        defaultMessage: 'Make a Block',
        description: 'Title for the modal where you create a custom block.',
        id: 'gui.customProcedures.myblockModalTitle'
    }
});

const numberTextTypeMessages = {
    ab: 'номер',
    af: 'nommer',
    ar: 'رقم',
    am: 'ቁጥር',
    an: 'número',
    ast: 'número',
    az: 'nömrə',
    id: 'nomor',
    bn: 'সংখ্যা',
    be: 'нумар',
    bg: 'номер',
    ca: 'número',
    cs: 'číslo',
    cy: 'rhif',
    da: 'nummer',
    de: 'Nummer',
    et: 'number',
    el: 'αριθμός',
    en: 'number',
    es: 'número',
    es_419: 'número',
    eo: 'nombro',
    eu: 'zenbakia',
    fa: 'عدد',
    fil: 'numero',
    fr: 'nombre',
    fy: 'nûmer',
    ga: 'uimhir',
    gd: 'àireamh',
    gl: 'número',
    ko: '숫자',
    ha: 'lamba',
    hy: 'համար',
    he: 'מספר',
    hi: 'संख्या',
    hr: 'broj',
    xh: 'inombolo',
    zu: 'inombolo',
    is: 'númer',
    it: 'numero',
    ka: 'რიცხვი',
    kk: 'нөмір',
    qu: 'número',
    sw: 'nambari',
    ht: 'nimewo',
    ku: 'hejmar',
    kmr: 'ژمارە',
    lv: 'numurs',
    lt: 'numeris',
    hu: 'szám',
    mi: 'nama',
    mn: 'тоо',
    nl: 'nummer',
    ja: '番号',
    nb: 'nummer',
    nn: 'nummer',
    oc: 'número',
    or: 'ସଂଖ୍ୟା',
    uz: 'raqam',
    th: 'หมายเลข',
    km: 'លេខ',
    pl: 'numer',
    pt: 'número',
    pt_BR: 'número',
    rap: 'tū\'iro',
    ro: 'număr',
    ru: 'номер',
    nso: 'nomoro',
    tn: 'nomoro',
    sk: 'číslo',
    se: 'nummir',
    sl: 'številka',
    sr: 'број',
    fi: 'numero',
    sv: 'nummer',
    vi: 'số',
    tr: 'numara',
    ts: 'nomoro',
    uk: 'номер',
    zh_CN: '数字',
    zh_TW: '數字'
};

const CustomProcedures = props => (
    <Modal
        className={styles.modalContent}
        contentLabel={props.intl.formatMessage(messages.myblockModalTitle)}
        onRequestClose={props.onCancel}
    >
        <Box
            className={styles.workspace}
            componentRef={props.componentRef}
        />
        <Box className={styles.body}>
            <div className={styles.optionsRow}>
                <div
                    className={styles.optionCard}
                    role="button"
                    tabIndex="0"
                    onClick={props.onAddTextNumber}
                >
                    <img
                        className={styles.optionIcon}
                        src={textInputIcon}
                    />
                    <div className={styles.optionTitle}>
                        <FormattedMessage
                            defaultMessage="Add an input"
                            description="Label for button to add a number/text input"
                            id="gui.customProcedures.addAnInputNumberText"
                        />
                    </div>
                    <div className={styles.optionDescription}>
                        {/* <FormattedMessage */}
                        {/*     defaultMessage="number" */}
                        {/*     description="Description of the number/text input type" */}
                        {/*     id="gui.customProcedures.numberTextType" */}
                        {/* /> */}
                        {numberTextTypeMessages[props.intl.locale] || numberTextTypeMessages.en}
                    </div>
                </div>
                <div
                    className={styles.optionCard}
                    role="button"
                    tabIndex="0"
                    onClick={props.onAddBoolean}
                >
                    <img
                        className={styles.optionIcon}
                        src={booleanInputIcon}
                    />
                    <div className={styles.optionTitle}>
                        <FormattedMessage
                            defaultMessage="Add an input"
                            description="Label for button to add a boolean input"
                            id="gui.customProcedures.addAnInputBoolean"
                        />
                    </div>
                    <div className={styles.optionDescription}>
                        <FormattedMessage
                            defaultMessage="boolean"
                            description="Description of the boolean input type"
                            id="gui.customProcedures.booleanType"
                        />
                    </div>
                </div>
                <div
                    className={styles.optionCard}
                    role="button"
                    tabIndex="0"
                    onClick={props.onAddLabel}
                >
                    <img
                        className={styles.optionIcon}
                        src={labelIcon}
                    />
                    <div className={styles.optionTitle}>
                        <FormattedMessage
                            defaultMessage="Add a label"
                            description="Label for button to add a label"
                            id="gui.customProcedures.addALabel"
                        />
                    </div>
                </div>
            </div>
            <div className={styles.checkboxRow}>
                <label>
                    <input
                        checked={props.warp}
                        type="checkbox"
                        onChange={props.onToggleWarp}
                    />
                    <FormattedMessage
                        defaultMessage="Run without screen refresh"
                        description="Label for checkbox to run without screen refresh"
                        id="gui.customProcedures.runWithoutScreenRefresh"
                    />
                </label>
            </div>
            <Box className={styles.buttonRow}>
                <button
                    className={styles.cancelButton}
                    onClick={props.onCancel}
                >
                    <FormattedMessage
                        defaultMessage="Cancel"
                        description="Label for button to cancel custom procedure edits"
                        id="gui.customProcedures.cancel"
                    />
                </button>
                <button
                    className={styles.okButton}
                    onClick={props.onOk}
                >
                    <FormattedMessage
                        defaultMessage="OK"
                        description="Label for button to save new custom procedure"
                        id="gui.customProcedures.ok"
                    />
                </button>
            </Box>
        </Box>
    </Modal>
);

CustomProcedures.propTypes = {
    componentRef: PropTypes.func.isRequired,
    intl: intlShape,
    onAddBoolean: PropTypes.func.isRequired,
    onAddLabel: PropTypes.func.isRequired,
    onAddTextNumber: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
    onToggleWarp: PropTypes.func.isRequired,
    warp: PropTypes.bool.isRequired
};

export default injectIntl(CustomProcedures);
